<template>
  <div class="appBody bg-grey-light min-vh-100  rec-course-list" v-if="obj">
    <little-header></little-header>
    <div v-if="obj.courseList && obj.courseList.length>0">
      <div class="course-item d-flex align-items-center rounded bg-white px-3 pt-3 pb-4 mb-20"
           ref="checkboxGroup" v-for="item in obj.courseList" :key="item.id">
        <div class="img" v-if="item.course.coverUrl"
             :style="{'background-image':'url('+uploadresUrl+item.course.coverUrl+')'}"></div>
        <div class="img" v-else :style="{'background-image':'url('+uploadresUrl+defaultCourseImg+')'}"></div>
        <div class="w-100 ml-12">
          <p class="mb-12 font-14 van-multi-ellipsis--l2 line-20">
            {{item.course.title}}
          </p>
          <div class="d-flex align-items-center justify-content-between w-100">
            <div class="color-66 font-10">
              {{(item.course.statInfo &&
              item.course.statInfo.mustLearnSessionCount) ? item.course.statInfo.mustLearnSessionCount : 0
              }}小节
            </div>

            <div class="font-11 color-88">
              <span v-if="obj.project.assessable && obj.project.standardScore > 0">积分：{{item.score}} </span>
              <span>学时:{{item.credit}}</span>
              <span v-if="item.haveCourse">[已拥有]</span>
              <span class="text-primary font-13" :class="{'text-decoration-through': item.haveCourse}"
                    v-if="item.free || item.price === 0.0">
              免费
            </span>
              <span class="color-88 font-11" :class="{'text-decoration-through': item.haveCourse}" v-else>
              ¥ {{item.price|getMoney}}
            </span>

            </div>
          </div>
        </div>

      </div>
      <div class="text-center pt-3 pb-5 mb-5">
        <img width="25%" :src="noMoreImage">
      </div>
      <div class="position-fixed bottom-fixed bg-grey-light">
        <div class="d-flex justify-content-between h-100 w-100 align-items-center">
          <div class="d-flex align-items-baseline select-right ml-auto h-100">
            <span class="font-14 color-66 mr-1">学时:{{obj.allCredit}}</span>
            <span class="font-14 color-66 mr-1" v-if="obj.allScore>0">积分:{{obj.allScore}}</span>
            <span class="font-22 text-primary mr-1">¥{{obj.allCost|getMoney}}</span>
            <div @click="showPayPage" class="bg-primary cursor-pointer text-white font-16 btnText h-100">
              <span>{{'确认('+obj.courseList.length+')'}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <no-data v-else text="尚未选择课程"></no-data>
  </div>

</template>

<script>
  import NoData from "@/components/noData";
  import LittleHeader from "@/components/littleHeader";

  import {mapState} from "vuex";
  import Vue from 'vue';
  import {Dialog} from "vant";

  Vue.use(Dialog);

  export default {
    name: "payResultPage",
    components: {
      NoData,
      LittleHeader
    },
    data() {
      return {
        obj: {},
        userId: ''
      }
    },
    computed: {
      ...mapState({
        uploadresUrl: state => state.uploadresUrl,
        noMoreImage: state => state.noMoreImage,
        defaultCourseImg: state => state.defaultCourseImg,
      })
    },
    destroyed() {
      // localStorage.removeItem('selectedObj')
    },
    mounted() {
      this.obj = JSON.parse(localStorage.getItem('selectedObj'));
    },
    methods: {
      showPayPage() {
        let ids = this.obj.courseList.map(v => {
          return {courseId: v.courseId}
        });
        if (this.obj.project.userProject) {
          this.userId = this.obj.project.userProject.userId;
        } else {
          this.userId = '';
        }
        this.userProject = {
          projectId: this.obj.project.id,
          userId: this.userId,
          courseList: ids
        };
        this.addLearnerProjectCourseBatch();
        // if (this.obj.allCost === 0) {
        //   this.addLearnerProjectCourseBatch();
        // } else {
        //   ///付费的
        //   this.$store.dispatch('listLearnerProjectCourseForOrderPreview', {
        //     id: this.obj.project.id,
        //     userProject: this.userProject
        //   }).then((res) => {
        //     if (res) {
        //       /// 支付
        //       this.addLearnerProjectCourseBatch();
        //     }
        //   }, (error) => {
        //     /// 错误提示
        //     if (error.response.data.consumerMessage) {
        //       this.$toast(error.response.data.consumerMessage)
        //     }
        //     ///已有订单
        //     else if (error.response.data.errorType === 'UserProjectAlreadyHasOrderException' &&
        //       error.response.data.userProject) {
        //       if (error.response.data.userProject.order.status === 'success') {
        //         // this.$toast('您已成功支付，即将进入！')
        //       } else {
        //         Dialog.confirm({
        //           title: '提示',
        //           message: '您已经存在购买该课程的订单！是否继续支付？',
        //         }).then(() => {
        //           //进支付页面
        //           this.$router.push('/order-detail/' + error.response.data.userProject.orderId)
        //         })
        //       }
        //     }
        //   })
        // }
      },
      addLearnerProjectCourseBatch() {
        this.$store.dispatch('addLearnerProjectCourseBatchUrl',
          {id: this.obj.project.id, title: this.obj.project.name, userProject: this.userProject}).then((res) => {
          if (res) {
            /// 免费项目直接通过
            if (this.obj.allCost === 0) {
              Dialog.confirm({
                title: '信息',
                message: '选课成功，请问您接下来打算？',
                confirmButtonText: '继续选课',
                cancelButtonText: '开始学习',
              }).then(() => {
                //继续选课
                this.$router.push('/recommend-project/' + this.obj.project.id);
              }).catch(() => {
                // 开始学习
                this.$router.push('/project/' + this.obj.project.id);
              });
            } else {
              /// 收费项目 进入支付页面
              this.$router.push('/pay/' + res.order.id)
            }
          }
        }, (error) => {
          /// 错误提示
          if (error.response.data.consumerMessage) {
            this.$toast(error.response.data.consumerMessage)
          }
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .rec-course-list {
    .bottom-fixed {
      border-top: 1px solid #e3e3e3a6;
    }

    .img {
      width: pxTorem(130px);
      height: pxTorem(58px);
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
    }

    .box {
      width: pxTorem(20px);
      height: pxTorem(20px);
      margin-right: pxTorem(10px);
      margin-top: pxTorem(2px);
    }

    .selectAll {
      padding-left: pxTorem(10px);
      width: pxTorem(80px);
    }

    .btnText {
      width: pxTorem(98px);
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

</style>
